import { makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles/createTheme";

export const useStyles = makeStyles((theme: Theme) => ({
    mainWrapper: {
        display: "flex",
        width: "100%",
        height: "100%",
        gap: theme.spacing(4),
    },
    noData: {
        height: "100% !important",
    },
    optionWrapper: {
        display: "flex",
        alignItems: "center",
        width: "100%",
        justifyContent: "center",
    },

    leftSection: {
        flex: 1,
    },
    rightSection: {
        "& .MuiTableContainer-root": {
            overflowX: "unset",
        },
        height: "100%",
        width: "40%",
        display: "flex",
        justifyContent: "center",
    },
}));
